import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './desktop/App';
import reportWebVitals from './reportWebVitals';

import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import HomePage from './desktop/pages/HomePage';
import Career from './desktop/pages/Career';
import Products from './desktop/pages/Products';
import TranslationService from './desktop/pages/TranslationService';
import WebHosting from './desktop/pages/WebHosting';
import AaoLens from './desktop/pages/AaoLens';
import Legal from './desktop/pages/Legal';

import MobileApp from './mobile/MobileApp';
import MobileHomePage from './mobile/pages/MobileHomePage';
import MobileCareer from './mobile/pages/MobileCareer';
import MobileProducts from './mobile/pages/MobileProducts';
import MobileTranslationService from './mobile/pages/MobileTranslationService';
import MobileWebHosting from './mobile/pages/WebHosting';
import MobileAaoLens from './mobile/pages/AaoLens';
import MobileLegal from './mobile/pages/Legal';



const landscape = () => {
  const screenHeight = window.innerHeight
  const screenWidth = window.innerWidth
  return screenWidth / screenHeight > 1
}
const root = ReactDOM.createRoot(document.getElementById('root'));
if(landscape()){
  const desktopRouter = createBrowserRouter([
    {
      element: <App></App>,
      children: [
        {
          path: "/",
          element: <HomePage/>,
        },
        {
          path: "products",
          element: (<Products/>),
        },
        {
          path: "translation-service",
          element: (<TranslationService/>),
        },
        {
          path: "webhosting-service",
          element: (<WebHosting/>),
        },
        {
          path: "products/aaolens",
          element: (<AaoLens/>),
        },
        {
          path: "careers",
          element: (<Career/>),
        },
        {
          path: "privacy",
          element: (<Legal doc="privacy"/>),
        },
        {
          path: "terms",
          element: (<Legal doc="terms"/>),
        }
      ]
    },

  ]);
  root.render(
    <React.StrictMode>
      <RouterProvider router={desktopRouter} />
    </React.StrictMode>
  );
}else{
  const mobileRouter = createBrowserRouter([
    {
      element: <MobileApp></MobileApp>,
      children: [
        {
          path: "/",
          element: <MobileHomePage/>,
        },
        {
          path: "products",
          element: (<MobileProducts/>),
        },
        {
          path: "translation-service",
          element: (<MobileTranslationService/>),
        },
        {
          path: "webhosting-service",
          element: (<MobileWebHosting/>),
        },
        {
          path: "products/aaolens",
          element: (<MobileAaoLens/>),
        },
        {
          path: "careers",
          element: (<MobileCareer/>),
        },
        {
          path: "privacy",
          element: (<MobileLegal doc="privacy"/>),
        },
        {
          path: "terms",
          element: (<MobileLegal doc="terms"/>),
        }
      ]
    },

  ]);
  root.render(
    <React.StrictMode>
      <RouterProvider router={mobileRouter} />
    </React.StrictMode>
  );
}


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
